import React from "react";

// Minimal inline markdown support: **bold**, *italic*, [text](url)
const MARKDOWN_TOKEN = /\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*|\*([^*]+)\*/g;

const parseInlineMarkdown = (text) => {
  const nodes = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = MARKDOWN_TOKEN.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }

    const [full, linkText, linkHref, boldText, italicText] = match;
    if (linkHref !== undefined) {
      nodes.push(
        <a key={key++} href={linkHref} target="_blank" rel="noopener noreferrer">
          {linkText}
        </a>
      );
    } else if (boldText !== undefined) {
      nodes.push(<strong key={key++}>{boldText}</strong>);
    } else if (italicText !== undefined) {
      nodes.push(<em key={key++}>{italicText}</em>);
    } else {
      nodes.push(full);
    }

    lastIndex = MARKDOWN_TOKEN.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
};

const MarkdownText = ({ children }) => {
  if (typeof children !== "string") return children;
  return <>{parseInlineMarkdown(children)}</>;
};

export default MarkdownText;